import { EventFlags } from './EventFlags';
import { CostPriority, SamplingPolicy, PersistencePriority, DataCategories, DiagnosticLevel } from './EventFlagsProperties';
import { TelemetryEvent } from './TelemetryEvent';
import { logNotification, LogLevel, Category } from '.';

/**
 * Gets EventFlags from a STE.TelemetryEvent, filling them with default values if they don't exist
 * @param telemetryEvent The telemetry event
 */
export function getEffectiveEventFlags(telemetryEvent: TelemetryEvent): EventFlags {
  let eventFlags: EventFlags = {
    costPriority: CostPriority.Normal,
    samplingPolicy: SamplingPolicy.Measure,
    persistencePriority: PersistencePriority.Normal,
    dataCategories: DataCategories.NotSet,
    diagnosticLevel: DiagnosticLevel.FullEvent
  };

  if (!telemetryEvent.eventFlags || !telemetryEvent.eventFlags.dataCategories) {
    logNotification(LogLevel.Error, Category.Core, () => 'Event is missing DataCategories event flag');
  }

  if (!telemetryEvent.eventFlags) {
    return eventFlags;
  }

  if (telemetryEvent.eventFlags.costPriority) {
    eventFlags.costPriority = telemetryEvent.eventFlags.costPriority;
  }

  if (telemetryEvent.eventFlags.samplingPolicy) {
    eventFlags.samplingPolicy = telemetryEvent.eventFlags.samplingPolicy;
  }

  if (telemetryEvent.eventFlags.persistencePriority) {
    eventFlags.persistencePriority = telemetryEvent.eventFlags.persistencePriority;
  }

  if (telemetryEvent.eventFlags.dataCategories) {
    eventFlags.dataCategories = telemetryEvent.eventFlags.dataCategories;
  }

  if (telemetryEvent.eventFlags.diagnosticLevel) {
    eventFlags.diagnosticLevel = telemetryEvent.eventFlags.diagnosticLevel;
  }

  return eventFlags;
}
